import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { GraphicMenuBuilder } from '../../models/builders/graphic-menu.builder';
import { getErrorHandlingOptions } from '../base/headers';
import { GraphicMenu } from '../../models/graphic-menu';

const graphicMenuBody = (graphicMenu: GraphicMenu) => ({
  name: graphicMenu.name,
  url: graphicMenu.url
});

@Injectable()
export class GraphicMenuApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }graphic-menus`;
  }

  getGraphicMenus() {
    return this.httpClient.get(`${ this.apiUrl }`, getErrorHandlingOptions())
      .pipe(
        map(GraphicMenuBuilder.fromList)
      );
  }

  getGraphicMenu(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }`)
      .pipe(
        map(GraphicMenuBuilder.fromJson)
      );
  }

  createGraphicMenu(graphicMenu) {
    return this.httpClient.post(this.apiUrl, graphicMenuBody(graphicMenu)).pipe(map(GraphicMenuBuilder.fromJson));
  }

  updateGraphicMenu(graphicMenu: GraphicMenu) {
    return this.httpClient.put(`${ this.apiUrl }/${ graphicMenu.hash }`, graphicMenuBody(graphicMenu));
  }

  deleteGraphicMenu(graphicMenu: GraphicMenu) {
    return this.httpClient.delete(`${ this.apiUrl }/${ graphicMenu.hash }`);
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/graphic-menu-api.service.ts